import React, { useEffect, useState } from 'react';
import { Accordion, Alert, Button, Col, Container, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import NavContainer from './Nav';
import OffCanvasNav from './OffCanvasNav';
import Titulo from '../elements/Titulo';
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { useAuth } from '../context/AuthContext';
import { storage } from '../firebase/firebaseConfig';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { Helmet } from 'react-helmet';

const ProductForm = () => {



  const [product, setProduct] = useState({
    name: '',
    description: '',
    id_category: '',
    id_supplier: ''
  });

  const { user } = useAuth();
  const [dataResponse, setDataResponse] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [selectedCategoryType, setSelectedCategoryType] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');

  const [selectedColor, setSelectedColor] = useState('');
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedWeight, setSelectedWeight] = useState('');

  const [selectedSupplier, setSelectedSupplier] = useState('');
  const [categoryTypes, setCategoryTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [products, setProducts] = useState([]);
  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [weight, setWeight] = useState([]);

  const [image, setImage] = useState(null);



  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  const [weightData, setWeightData] = useState({
    weight_name: ''
  });

  const [sizeData, setSizeData] = useState({
    size_name: ''
  });

  const [colorData, setColorData] = useState({
    color_name: ''
  });

  const [showModal, setShowModal] = useState(false); // Para manejar el modal de selección de producto
  const [selectedProduct, setSelectedProduct] = useState(null); // Producto seleccionado
  const [filteredProductsBy, setFilteredProducts] = useState([]); // Productos filtrados para la tabla

  /* ITEMS */

  const [itemData, setItemData] = useState({
    id_product: '',
    id_color: '',
    id_weight: '',
    id_size: '',
    stock: '',
    price: '',
    description: '',
    url: ''
  });

  const [searchTerm, setSearchTerm] = useState(''); // Para el buscador
  const handleChange = (e) => {
    setProduct({
      ...product,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmitProduct = async (e) => {
    e.preventDefault();
    try {
      const { data } = await dotoniwoofApi.post("/product.php",
        JSON.stringify({
          firebase_UID: user.uid,
          name: product.name,
          description: product.description,
          id_category: selectedCategory
        }));
      setDataResponse(data);
      if (data.code === 201) {
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 3000); // Ocultar alerta de éxito después de 3 segundos
        setProduct({ name: '', description: '', id_category: '', id_supplier: '' });
        setSelectedCategory('');
        setSelectedCategoryType('');
        setSelectedSupplier('');
        getProducts();
      } else {
        throw new Error('Failed to save category type');
      }
    } catch (error) {
      setShowErrorAlert(true);
      setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
    }
  };

  const handleSubmitWeight = async (e) => {
    e.preventDefault();
    try {
      const { data } = await dotoniwoofApi.post("/weight.php",
        JSON.stringify({
          firebase_UID: user.uid,
          weight_name: weightData.weight_name,
        }));
      setDataResponse(data);
      if (data.code === 201) {
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 3000); // Ocultar alerta de éxito después de 3 segundos
        setWeightData({ weight_name: '' });
        getWeight();
      } else {
        throw new Error('Failed to save category type');
      }
    } catch (error) {
      setShowErrorAlert(true);
      setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
    }
  };


  const handleSubmitSize = async (e) => {
    e.preventDefault();
    try {
      const { data } = await dotoniwoofApi.post("/size.php",
        JSON.stringify({
          firebase_UID: user.uid,
          size_name: sizeData.size_name
        }));
      setDataResponse(data);
      if (data.code === 201) {
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 3000); // Ocultar alerta de éxito después de 3 segundos
        setSizeData({ size_name: '' });
        getSize();
      } else {
        throw new Error('Failed to save category type');
      }
    } catch (error) {
      setShowErrorAlert(true);
      setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
    }
  };


  const handleSubmitColor = async (e) => {
    e.preventDefault();
    try {
      const { data } = await dotoniwoofApi.post("/color.php",
        JSON.stringify({
          firebase_UID: user.uid,
          color_name: colorData.color_name
        }));
      setDataResponse(data);
      if (data.code === 201) {
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 3000); // Ocultar alerta de éxito después de 3 segundos
        setColorData({ color_name: '' });
        getColor();
      } else {
        throw new Error('Failed to save category type');
      }
    } catch (error) {
      setShowErrorAlert(true);
      setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
    }
  };

  const handleChangeWight = (e) => {
    const { name, value } = e.target;
    setWeightData({
      [name]: value
    });
  };

  const handleChangeSize = (e) => {
    const { name, value } = e.target;
    setSizeData({
      [name]: value
    });
  };

  const handleChangeColor = (e) => {
    const { name, value } = e.target;
    setColorData({
      [name]: value
    });
  };

  const handleChangeItems = (e) => {
    const { name, value } = e.target;
    setItemData({
      ...itemData,
      [name]: value
    });
  };

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  const metadata = {
    contentType: 'image/jpeg'
  };

  const handleImageUpload = async (callback) => {
    if (image) {

      const newFileName = `image_${Date.now()}.${image.name.split('.').pop()}`;
      const storageRef = ref(storage, `items/${newFileName}`);
      const uploadTask = uploadBytesResumable(storageRef, image, metadata);

      uploadTask.on('state_changed',
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case 'paused':
              console.log('Upload is paused');
              break;
            case 'running':
              console.log('Upload is running');
              break;
          }
        },
        (error) => {
          console.log(error.code);
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break;
            case 'storage/canceled':
              // User canceled the upload
              break;

            // ...

            case 'storage/unknown':
              // Unknown error occurred, inspect error.serverResponse
              break;
          }
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            callback(downloadURL);
          });
        }
      );
    }
  };
  const waitTwoSeconds = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve('Waited for 2 seconds');
      }, 2000); // 2000 ms = 2 seconds
    });
  };

  const handleSubmitItem = (e) => {
    e.preventDefault();
    setLoading(true);
    handleImageUpload((imageUrl) => {
      sendDataToApi(imageUrl)
    });
  };

  const sendDataToApi = async (imageUrl) => {
    try {
      const { data } = await dotoniwoofApi.post("/item.php",
        JSON.stringify({
          firebase_UID: user.uid,
          id_product: selectedProduct.id_product,
          id_color: selectedColor,
          id_weight: selectedWeight,
          id_size: selectedSize,
          id_supplier: selectedSupplier,
          stock: itemData.stock,
          price: itemData.price,
          description: itemData.description,
          url: imageUrl
        }));
      setDataResponse(data);
      if (data.code === 201) {
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 3000); // Ocultar alerta de éxito después de 3 segundos
        setSizeData({ size_name: '' });
        setItemData({ id_product: '', id_color: '', id_weight: '', id_size: '', stock: '', price: '', description: '', url: '' });
        setImage(null);
        setSelectedProduct(null);
        setSelectedColor('');
        setSelectedWeight('');
        setSelectedSize('');
      } else {
        throw new Error('Failed to save category type');
      }
    } catch (error) {
      setShowErrorAlert(true);
      setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {

    const fetchSuppliers = async () => {
      await dotoniwoofApi.get(`/supplier.php`)
        .then(res => {
          let responseApi = res.data;
          if (responseApi.code === 200) {
            setSuppliers(responseApi.message);
          }
        })
        .catch(err => {
          console.log(err);
        }).finally(
          () => {
            setLoading(false);
          }
        )
    }

    const getCategoryType = async () => {
      await dotoniwoofApi.get(`/categoryType.php`)
        .then(res => {
          let responseApi = res.data;
          if (responseApi.code === 200) {
            setCategoryTypes(responseApi.message);
          }

        })
        .catch(err => {
          console.log(err);
        }).finally(
          () => {
            setLoading(false);
          }
        )
    }

    getColor();
    getSize();
    getWeight();
    getProducts();
    getCategoryType();
    fetchSuppliers();
  }, []);


  const getColor = async () => {
    await dotoniwoofApi.get(`/color.php`)
      .then(res => {
        let responseApi = res.data;
        if (responseApi.code === 200) {
          setColors(responseApi.message);
        }

      })
      .catch(err => {
        console.log(err);
      }).finally(
        () => {
          setLoading(false);
        }
      )
  }

  const getSize = async () => {
    await dotoniwoofApi.get(`/size.php`)
      .then(res => {
        let responseApi = res.data;
        if (responseApi.code === 200) {
          setSizes(responseApi.message);
        }

      })
      .catch(err => {
        console.log(err);
      }).finally(
        () => {
          setLoading(false);
        }
      )
  }

  const getWeight = async () => {
    await dotoniwoofApi.get(`/weight.php`)
      .then(res => {
        let responseApi = res.data;
        if (responseApi.code === 200) {
          setWeight(responseApi.message);
        }

      })
      .catch(err => {
        console.log(err);
      }).finally(
        () => {
          setLoading(false);
        }
      )
  }

  useEffect(() => {
    setFilteredProducts(
      products.filter((product) =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, products]);


  const getProducts = async () => {
    await dotoniwoofApi.get(`/product.php`)
      .then(res => {
        let responseApi = res.data;
        if (responseApi.code === 200) {
          setProducts(responseApi.message);
        }

      })
      .catch(err => {
        console.log(err);
      }).finally(
        () => {
          setLoading(false);
        }
      )
  };

  const getCategoryByType = async (categoryType) => {
    await dotoniwoofApi.get(`/category.php/${categoryType}`)
      .then(res => {
        let responseApi = res.data;
        if (responseApi.code === 200) {
          setCategories(responseApi.message);
        } else {
          setCategories([]);
        }

      })
      .catch(err => {
        console.log(err);
      }).finally(
        () => {
          setLoadingCategories(false);
        }
      )
  }

  const handleCategoryTypeChange = (e) => {
    const categoryTypeId = e.target.value;
    setSelectedCategoryType(categoryTypeId);
    if (categoryTypeId) {
      getCategoryByType(categoryTypeId); // Obtener categorías basadas en el tipo seleccionado
    } else {
      setCategories([]); // Vaciar categorías si no se selecciona ningún tipo
    }
  };

  const handleCategoryChange = (e) => {
    const categoryId = e.target.value;
    setSelectedCategory(categoryId);
  };

  const handleSupplierChange = (e) => {
    const supplierId = e.target.value;
    setSelectedSupplier(supplierId);
  };

  const handleColorChange = (e) => {
    const colorID = e.target.value;
    setSelectedColor(colorID);
  };

  const handleSizeChange = (e) => {
    const SizeID = e.target.value;
    setSelectedSize(SizeID);
  };

  const handleWeightChange = (e) => {
    const WeightID = e.target.value;
    setSelectedWeight(WeightID);
  };

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleProductSelect = (product) => {
    setSelectedProduct(product);
    setShowModal(false); // Cerrar el modal al seleccionar el producto
  };


  return (

    <>
      <Helmet><title>
        Administracion Productos
      </title></Helmet>
      <NavContainer></NavContainer>
      <OffCanvasNav></OffCanvasNav>
      <Container >
        <Titulo>Creación de producto</Titulo>
        <hr></hr>
        <Row >
          <Col >
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Creación de producto</Accordion.Header>
                <Accordion.Body>
                  {/* Alerta de confirmación de éxito */}
                  {showSuccessAlert && (
                    <Alert variant="success">
                      {dataResponse.message}
                    </Alert>
                  )}
                  {/* Alerta de error */}
                  {showErrorAlert && (
                    <Alert variant="danger">
                      ERROR AL CREAR EL PRODUCTO
                    </Alert>
                  )}
                  <h2>Creación de nuevo producto</h2>
                  <Form onSubmit={handleSubmitProduct}>
                    {/* Product Name */}
                    <Form.Group controlId="formProductName">
                      <Form.Label><strong>Nombre del producto</strong></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Digite el nombre del producto"
                        name="name"
                        value={product.name}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                    {/* Description */}
                    <Form.Group controlId="formProductDescription">
                      <Form.Label><strong>Descripción</strong></Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Digite la descripción del producto"
                        name="description"
                        value={product.description}
                        onChange={handleChange}
                      />
                    </Form.Group>
                    {/* Category */}
                    <Form.Group controlId="categoryTypeSelect">
                      <Form.Label><strong>Tipo de categoría</strong></Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedCategoryType}
                        onChange={handleCategoryTypeChange}
                      >
                        <option value="">-- Seleccione el tipo de categoría --</option>
                        {categoryTypes.map((type) => (
                          <option key={type.id_category_type} value={type.id_category_type}>
                            {type.categoryTypeName}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                    {/* Category */}
                    {categories &&
                      <Form.Group controlId="categoryTypeSelect">
                        <Form.Label><strong>Categoría</strong></Form.Label>
                        <Form.Control
                          as="select"
                          value={selectedCategory}
                          onChange={handleCategoryChange}
                        >
                          <option value="">-- Seleccione la categoría --</option>
                          {categories.map((type) => (
                            <option key={type.id_category} value={type.id_category}>
                              {type.category_name}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    }
                    <br></br>
                    {/* Submit Button */}
                    <Button variant="primary" type="submit">
                      Crear Producto
                    </Button>
                  </Form>
                  <br></br>
                  {/* Tabla para productos */}
                  {/* Campo de búsqueda */}
                  <Form.Group controlId="searchProduct">
                    <Form.Label>Buscar Productos</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Buscar por nombre del producto"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </Form.Group>

                  <hr></hr>

                  {!loading && filteredProducts.length > 0 && (
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th>Descripción</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredProducts.map((product) => (
                          <tr key={product.id_product}>
                            <td>{product.name}</td>
                            <td>{product.description}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}

                  {/* Mensaje cuando no se encuentran productos */}
                  {!loading && filteredProducts.length === 0 && (
                    <Alert variant="info">
                      No products found.
                    </Alert>
                  )}
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>Creacion de Pesos por Gramaje</Accordion.Header>
                <Accordion.Body>
                  {/* Alerta de confirmación de éxito */}
                  {showSuccessAlert && (
                    <Alert variant="success">
                      {dataResponse.message}
                    </Alert>
                  )}

                  {/* Alerta de error */}
                  {showErrorAlert && (
                    <Alert variant="danger">
                      ERROR AL CREAR GRAMAJE
                    </Alert>
                  )}
                  <h4>Crear Gramaje</h4>
                  <br></br>
                  <Form onSubmit={handleSubmitWeight}>
                    {/* Nombre del Proveedor */}
                    <Form.Group controlId="formWeightName">
                      <Form.Label><strong>Nombre</strong></Form.Label>
                      <Form.Control
                        type="text"
                        name="weight_name"
                        value={weightData.weight_name}
                        onChange={handleChangeWight}
                        placeholder="Digite el gramaje"
                        required
                      />
                    </Form.Group>
                    <br></br>

                    {/* Botón de envío */}
                    <Button variant="primary" type="submit">
                      Crear Gramaje
                    </Button>
                  </Form>

                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Creacion de Tallas</Accordion.Header>
                <Accordion.Body>
                  {/* Alerta de confirmación de éxito */}
                  {showSuccessAlert && (
                    <Alert variant="success">
                      {dataResponse.message}
                    </Alert>
                  )}

                  {/* Alerta de error */}
                  {showErrorAlert && (
                    <Alert variant="danger">
                      ERROR AL CREAR TALLA
                    </Alert>
                  )}
                  <h4>Crear Talla</h4>
                  <br></br>
                  <Form onSubmit={handleSubmitSize}>
                    {/* Nombre del tallaje */}
                    <Form.Group controlId="formSizeName">
                      <Form.Label><strong>Nombre</strong></Form.Label>
                      <Form.Control
                        type="text"
                        name="size_name"
                        value={sizeData.size_name}
                        onChange={handleChangeSize}
                        placeholder="Digite la talla"
                        required
                      />
                    </Form.Group>
                    <br></br>

                    {/* Botón de envío */}
                    <Button variant="primary" type="submit">
                      Crear Talla
                    </Button>
                  </Form>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>Creacion de Colores</Accordion.Header>
                <Accordion.Body>
                  {/* Alerta de confirmación de éxito */}
                  {showSuccessAlert && (
                    <Alert variant="success">
                      {dataResponse.message}
                    </Alert>
                  )}

                  {/* Alerta de error */}
                  {showErrorAlert && (
                    <Alert variant="danger">
                      ERROR AL CREAR EL COLOR
                    </Alert>
                  )}
                  <h4>Crear Color</h4>
                  <br></br>
                  <Form onSubmit={handleSubmitColor}>
                    {/* Nombre del tallaje */}
                    <Form.Group controlId="formColorName">
                      <Form.Label><strong>Nombre</strong></Form.Label>
                      <Form.Control
                        type="text"
                        name="color_name"
                        value={colorData.color_name}
                        onChange={handleChangeColor}
                        placeholder="Digite el Color"
                        required
                      />
                    </Form.Group>
                    <br></br>

                    {/* Botón de envío */}
                    <Button variant="primary" type="submit">
                      Crear Color
                    </Button>
                  </Form>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>Creacion de Items</Accordion.Header>
                <Accordion.Body>

                  {/* Alerta de confirmación de éxito */}
                  {showSuccessAlert && (
                    <Alert variant="success">
                      {dataResponse.message}
                    </Alert>
                  )}

                  {/* Alerta de error */}
                  {showErrorAlert && (
                    <Alert variant="danger">
                      ERROR AL CREAR EL PRODUCTO
                    </Alert>
                  )}

                  <h4>Crear Item</h4>
                  <br></br>
                  {/* Formulario de creación de ítems */}
                  <Form onSubmit={handleSubmitItem}>
                    {/* Selección del producto padre */}
                    <Form.Group controlId="formProductId">
                      <Form.Label><strong>Producto Padre</strong></Form.Label>
                      <br></br>
                      <Button variant="secondary" onClick={() => setShowModal(true)}>
                        {selectedProduct ? selectedProduct.name : 'Seleccione el producto padre'}
                      </Button>
                    </Form.Group>

                    <Form.Group controlId="formItemDescription">
                      <Form.Label><strong>Descripcion del item</strong></Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={itemData.description}
                        onChange={handleChangeItems}
                        placeholder="Digite la descripcion del item"
                        required
                      />
                    </Form.Group>

                    {/* Proveedor */}
                    <Form.Group controlId="categoryTypeSelect">
                      <Form.Label><strong>Proveedor</strong></Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedSupplier}
                        onChange={handleSupplierChange}
                      >
                        <option value="">-- Seleccione el proveedor --</option>
                        {suppliers.map((type) => (
                          <option key={type.id_supplier} value={type.id_supplier}>
                            {type.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    {/* Nombre del ítem */}
                    <Form.Group controlId="formItemStock">
                      <Form.Label><strong>Stock</strong></Form.Label>
                      <Form.Control
                        type="number"
                        name="stock"
                        value={itemData.stock}
                        onChange={handleChangeItems}
                        placeholder="Digite el stock"
                        required
                      />
                    </Form.Group>

                    <Form.Group controlId="formItemPrice">
                      <Form.Label><strong>Precio</strong></Form.Label>
                      <Form.Control
                        type="number"
                        name="price"
                        value={itemData.price}
                        onChange={handleChangeItems}
                        placeholder="Digite el precio"
                        required
                      />
                    </Form.Group>

                    {/* Color */}
                    <Form.Group controlId="colorSelect">
                      <Form.Label><strong>Color</strong></Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedColor}
                        onChange={handleColorChange}
                      >
                        <option value="">-- Seleccione el color --</option>
                        {colors.map((type) => (
                          <option key={type.id_color} value={type.id_color}>
                            {type.color_name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    {/* Peso */}
                    <Form.Group controlId="weightSelect">
                      <Form.Label><strong>Gramaje</strong></Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedWeight}
                        onChange={handleWeightChange}
                      >
                        <option value="">-- Seleccione el gramaje --</option>
                        {weight.map((type) => (
                          <option key={type.id_weight} value={type.id_weight}>
                            {type.weight_name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    {/* Tamaño */}
                    <Form.Group controlId="sizeTypeSelect">
                      <Form.Label><strong>Tamaño</strong></Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedSize}
                        onChange={handleSizeChange}
                      >
                        <option value="">-- Seleccione el tamaño --</option>
                        {sizes.map((type) => (
                          <option key={type.id_size} value={type.id_size}>
                            {type.size_name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    {/* Carga de imagen */}
                    <Form.Group controlId="formImage">
                      <Form.Label><strong>Imagen del item</strong></Form.Label>
                      <Form.Control type="file" onChange={handleImageChange} required />
                    </Form.Group>
                    <br></br>
                    {/* Botón de envío */}
                    <Button variant="primary" type="submit">
                      {loading ? <Spinner animation="border" size="sm" /> : 'Crear Item'}
                    </Button>
                  </Form>

                  {/* Modal de selección de producto */}
                  <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                    <Modal.Header closeButton>
                      <Modal.Title>Seleccionar producto Padre</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form.Group controlId="formSearch">
                        <Form.Label>Buscar producto</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Buscar por producto"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </Form.Group>
                      <br></br>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>Product Name</th>
                            <th>Category</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredProductsBy.map((product) => (
                            <tr key={product.id_product}>
                              <td>{product.name}</td>
                              <td>
                                <Button
                                  variant="primary"
                                  onClick={() => handleProductSelect(product)}
                                >
                                  Seleccionar
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </Modal.Body>
                  </Modal>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ProductForm;